import { lazy } from "react";
export const CitationTrajectoryAsync = lazy(()=>import("./CitationTrajectoryPage"))